<template>
    <DCard padding>
        <DTable
            :fields="[
                {key: 'id', label: __('settings.dns_providers.index.table.headers.id'), sorter: false, filter: false},
                {key: 'name', label: __('settings.dns_providers.index.table.headers.name'), sorter: false, filter: false},
                {key: 'is_default', label: __('settings.dns_providers.index.table.headers.isDefault'), sorter: false, filter: false},
                {key: 'actions', label: __('messages.actions.actions'), sorter: false, filter: false}
            ]"
            :items="tableItems"
            class="mb-0"
        >
            <template #id="{item}">
                <td style="width: 70px;">
                    {{ item.id }}
                </td>
            </template>
            <template #name="{item}">
                <td style="justify-content: center;">
                    {{ item.name }}
                </td>
            </template>
            <template #is_default="{item}">
                <td style="width: 110px;">
                    <DBadge :color="item.is_default ? 'success' : 'secondary'">
                        {{ item.is_default ? __('settings.dns_providers.index.table.values.default.yes') : __('settings.dns_providers.index.table.values.default.no') }}
                    </DBadge>
                </td>
            </template>
            <template #actions="{item}">
                <td style="width: 350px">
                    <div style="display: flex; align-items: center; grid-gap: 10px;">
                        <DButton
                            :id="`make_default_${item.id}`"
                            icon="check-circle-outline"
                            :label="__('messages.actions.makeDefault')"
                            mini
                            :disabled="item.is_default === 1"
                            @click="$inertia.put($route('settings.dns-providers.make-default', {dns_provider: item.id}))"
                        />
                        <DButton
                            :id="`view_${item.id}`"
                            icon="eye"
                            mini
                            @click="$inertia.get($route('settings.dns-providers.show', {dns_provider: item.id}))"
                        />
                        <DButton
                            v-if="userPermissions.includes('settings.dns')"
                            :id="`edit_${item.id}`"
                            icon="pencil"
                            mini
                            @click="$inertia.get($route('settings.dns-providers.edit', {dns_provider: item.id}))"
                        />
                        <DButton
                            v-if="userPermissions.includes('settings.dns')"
                            :id="`btn-delete-${item.id}`"
                            icon="trash-can-outline"
                            color="danger"
                            mini
                            :disabled="canNotBeDeleted(item)"
                            @click="deleteDNSProvider(item.id)"
                        />
                    </div>
                </td>
            </template>
        </DTable>
        <DPagination
            v-if="dnsProviders.last_page > 1"
            :active-page="dnsProviders.current_page"
            :pages="dnsProviders.last_page"
            align="center"
            @update:activePage="changePage"
        />

        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('settings.dns_providers.index.addButton')"
                @click="$inertia.get($route('settings.dns-providers.create'))"
            />
        </DFabs>
        <DModal
            v-model:show="showConfirmationModal"
            :title="__('products.products.index.deleteConfirmation.title')"
            :message="__('products.products.index.deleteConfirmation.message')"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deleteCallBack"
        />
    </DCard>
</template>

<script>
export default {
    name: 'DNSProvidersIndex',
    props: {
        dnsProviders: {
            type: Object,
            default () {
                return {}
            }
        },
        usedProviders: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data () {
        return {
            showConfirmationModal: false,
            deleteCallBack: () => { return {} }
        }
    },
    computed: {
        tableItems () {
            const items = []
            this.dnsProviders.data.forEach(dnsProvider => {
                items.push(dnsProvider)
            })

            return items
        },
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    methods: {
        deleteDNSProvider (id) {
            this.deleteCallBack = () => {
                this.$inertia.delete(this.$route('settings.dns-providers.destroy', { dns_provider: id }))
                this.showConfirmationModal = false
            }
            this.showConfirmationModal = true
        },
        changePage (page) {
            // @todo test if works
            const query = {}

            if (page > 1) {
                query.page = page
            }

            this.$inertia.get(this.$route('settings.dns-providers.index'), query)
        },
        canNotBeDeleted (item) {
            const id = item.id
            const isUsed = this.usedProviders.includes(id)
            return isUsed || item.is_default === 1
        }
    }
}
</script>

<style scoped lang="scss">

</style>
